/**
 * SpawnAddActionDialog Component
 *
 * Launcher modal with 3 action cards for spawn operations:
 * - Create Batch (single strain from LC/syringe)
 * - Add Inventory (third-party purchased spawn)
 * - Create Session (Odin recommends inoculation plan)
 */

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { FlaskConical, Package, Calendar } from 'lucide-react'

const ACTIONS = [
  {
    key: 'batch',
    icon: FlaskConical,
    title: 'Create Batch',
    description: 'Single strain batch from LC or syringe'
  },
  {
    key: 'inventory',
    icon: Package,
    title: 'Add Inventory',
    description: 'Record third-party purchased spawn'
  },
  {
    key: 'session',
    icon: Calendar,
    title: 'Create Session',
    description: 'Odin recommends inoculation plan'
  }
]

export default function SpawnAddActionDialog({ open, onOpenChange, onSelectAction }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="odin-modal-small">
        <DialogHeader>
          <DialogTitle>Add Spawn</DialogTitle>
        </DialogHeader>

        <div className="grid gap-3 py-2">
          {ACTIONS.map((action) => (
            <div
              key={action.key}
              role="button"
              tabIndex={0}
              onClick={() => onSelectAction(action.key)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  onSelectAction(action.key)
                }
              }}
              className="flex items-center gap-4 p-4 rounded-lg border border-border
                cursor-pointer transition-colors
                hover:bg-surface-secondary hover:border-border-strong
                focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            >
              <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-surface-secondary flex items-center justify-center">
                <action.icon className="h-5 w-5 text-content-secondary" />
              </div>
              <div>
                <p className="font-medium text-sm text-content-primary">{action.title}</p>
                <p className="text-xs text-content-tertiary">{action.description}</p>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  )
}
